import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'securaze-api',
    pluginName: 'ADMIN',
    entityName: 'SECURAZE_API',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch api keys action creators
export const fetchApiKeysInit = () => {
    return crudActions.fetchInit();
};
export const fetchApiKeysStart = () => {
    return crudActions.fetchStart();
};
export const fetchApiKeysSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchApiKeysFail = () => {
    return crudActions.fetchFail();
};
export const fetchApiKeysCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchApiKeysStart());
        try {
            let countRes = await rest.post("/securaze-api/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchApiKeysSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchApiKeysFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch api keys."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchApiKeysFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch api keys."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchApiKeys = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchApiKeysStart());
        try {
            let listRes = await rest.post("/securaze-api/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchApiKeysSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchApiKeysFail());
            return []

        } catch (error) {
            dispatch(fetchApiKeysFail());
            return []
        }
    }
}

// Load api key action creators
export const loadApiKeyInit = () => {
    return crudActions.loadInit();
};
export const loadApiKeyStart = () => {
    return crudActions.loadStart();
};
export const loadApiKeySuccess = loadedApiKey => {
    return crudActions.loadSuccess(loadedApiKey);
};
export const loadApiKeyFail = error => {
    return crudActions.loadFail(error);
};
export const loadApiKey = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create api key action creators
export const createApiKeyInit = () => {
    return crudActions.createInit();
};
export const createApiKeyStart = () => {
    return crudActions.createStart();
};
export const createApiKeySuccess = createdApiKey => {
    return crudActions.createSuccess(createdApiKey);
};
export const createApiKeyFail = error => {
    return crudActions.createFail(error);
};

export const createApiKey = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createApiKeyStart());
        try {
            let res = await rest.post('/securaze-api/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created securaze api.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createApiKeyFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create api key."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create api key."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createApiKeyFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit api key action creators
export const editApiKeyInit = () => {
    return crudActions.editInit();
};
export const editApiKeyStart = () => {
    return crudActions.editStart();
};
export const editApiKeySuccess = editedApiKey => {
    return crudActions.editSuccess(editedApiKey);
};
export const editApiKeyFail = error => {
    return crudActions.editFail(error);
};

export const editApiKey = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editApiKeyStart());
        try {
            let res = await rest.post('/securaze-api/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated api key.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editApiKeyFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit api key."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit api key."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editApiKeyFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete api keys action creators
export const bulkDeleteApiKeysInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteApiKeysStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteApiKeysSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteApiKeysFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteApiKeys = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteApiKeysStart());
        try {
            let res = await rest.post('/securaze-api/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteApiKeysSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted api keys.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteApiKeysFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete api keys."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete api keys."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteApiKeysFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};